import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PostLoginVideo from './PostLoginVideo';

function PostLoginVideoPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
    }
  }, [navigate, token]);

  if (!token) {
    return null;
  }

  return (
    <PostLoginVideo
      onComplete={() => navigate('/welcome', { replace: true })}
    />
  );
}

export default PostLoginVideoPage;
